module.exports = __webpack_public_path__ + "img/success-icon.ca62008b.png";